import { isApp } from '@/common/util/common'

/**
 * list back event (new version)
 * 기존 코드 hook 에서 분리
 * @param route
 * @param router
 * @returns {void | string}
 */
export const onClickListBack = (route, router) => {
  if (isApp()) {
    location.href = 'captvpooq://webclose'
  }

  const referrer = route?.query?.referrer || null
  const came = route?.query?.came || null

  const moveWithReferrer = () => {
    if (referrer.includes('mypooq')) {
      return router.push('/mypooq').catch(() => {})
    } else {
      return router.replace(`/referrer`).catch(() => {})
    }
  }

  const moveWithoutReferrer = () => {
    if (came !== null && came !== '') {
      return router.push({ name: came }).catch(() => {})
    } else {
      return router.back()
    }
  }

  referrer !== null ? moveWithReferrer() : moveWithoutReferrer()
}
